import GroupForm from '../../../../../components/group/form/form'
import Offcanvas from '../../../../../components/new_offcanvas/offcanvas_menu'
import _http_v1 from '../../../../../http_requests/_http_v1'
import Buttons from './components/buttons'
import ButtonGroup from './components/button_group'
import Count from './components/count'
import FastSelectBox from './components/fast_select_box'
import GroupList from './components/group_list'
import List from './components/list'
import Search from './components/search'
import toast from './../../../../../components/toast/toast'

export default function OffcanvasStations(opts){

    let selectors = {
        search: "#search_container"
    }
    let ids = {
        search: "search_container"
    }

    let offcanvas = new Offcanvas({
        id: opts.id,
        title: "Selecionar Postos",
        subtitle: "Selecionar postos para consulta de dados",
        height: "offcanvas-hlg"
    })
    let _station = opts.station || {}
    let GENERAL_OPTIONS = opts.general_options
    let list = new List({container: "#list_container", station: _station})
    let search = new Search({container: selectors.search})
    let count = new Count({container:"#count_container", station: _station.list})
    let fast_select_box = new FastSelectBox({container: "#fast_select_box_container", station: _station})
    let group_list,button_group_list,group_form;

    let buttons;
    
    this.generate = () =>{
        offcanvas.generate()
        //adicionando containers adicionais no offcanvas. A idéia é ter multiplas paginas dentro do mesmo
        this.addWrapper('groups-view')
        this.addWrapper('groups-form')

        //adicionando as divs que serão containers dentro do offcanvas
        offcanvas.appendToBody("<div class='row'><div class='col-md-9' id='"+ids.search+"'></div><div class='col-md-3'><div id='button_groups_container'></div></div><div>")
        offcanvas.appendToBody("<div id='list_container'></div>")
        offcanvas.appendToBody("<div id='count_container'></div>")
        offcanvas.appendToBody("<div id='buttons_container'></div>")
        offcanvas.appendToBody("<div id='fast_select_box_container'></div>")

        //adicionando divs quer serão containers dentro do offcanvas, MAS EM WRAPPERS DIFERENTES (por padrão, appendToBody coloca o conteudo dentro do wrapper .content)
        offcanvas.appendToBody("<div id='group_list_container'></div>", ".groups-view")
        offcanvas.appendToBody("<div id='group_form_container'></div>", ".groups-form")

        //inicializando componente de botões (limparSeleções e Selecionados)
        buttons = new Buttons({container: "#buttons_container", clear_func:this.clearSelections, only_selected_func:this.filter})
        
        //gerando lista de postos
        list.generate()

        //gerando caixa de pesquisa de posto
        search.generate()

        //gerando botões
        buttons.generate()

        //gerando contador
        count.generate()

        //gerando caixa para seleção rapida de postos
        fast_select_box.generate()
        
        //só gera items refente a grupos caso usuário esteja logado
        if(cookies.user_token){
            //inicializando componente com a lista de grupos (OUTRO WRAPPER)
            group_list = new GroupList({container: "#group_list_container", general_options: GENERAL_OPTIONS, button_destroy_onclick: this.destroyGroup,button_edit_onclick: this.toGroupForm, button_new_onclick: this.toGroupForm, button_back_onclick: this.toStationList})
            
            //inicializando botão que leva a lista de grupos (tem que ser agora por conta de mandar um função como parâmetro)
            button_group_list = new ButtonGroup({container: "#button_groups_container", onclick: this.toGroupList})

            //gerando botão para abrir lista de grupos
            button_group_list.generate()
        }
        
        //eventsHandler
        eventHandler.call(this)
    }

    this.reloadList = () =>{
        //exibindo/escondendo itens de acordo com o filtro geral
        list.reload()
    }
    /**
     * Filtra a lista de postos de acordo com o texto digitado
     * Lembrando que só aparecem as opções que também estão validas de acordo com o filtro geral (station.show = true)
     */
    this.filter = () =>{
        let params = [['complete_name', search.getCurrentText()]]
        if(buttons.getSelectedStatus()){
            params.push(['selected',true])
        }
        list.filter(params)
    }

    /**
     * Controla exibição do ListItem de acordo com o boolean. Utiliza o método interno listItem para esconder/exibir
     * @param {Object} listItem 
     * @param {Boolean} boolean 
     */
    this.showListItem = (listItem, boolean) =>{
        listItem.setShow(boolean)
    }

    this.clearSelections = (boolean = false) => {
        list.selectAll(false)
    }

    this.show = () =>{
        offcanvas.show()
    }
    this.hide = () =>{
        offcanvas.hide()
    }

    this.toStationList = () =>{
        //alterando titulo/subtitulo do offcanvas
        offcanvas.updateTitles("Selecionar Postos", "Selecionar postos para consulta de dados")
        //escondendno wrapper .content
        offcanvas.hideContent('.groups-view')
        //escondendo wrapper .groups-form
        offcanvas.hideContent('.groups-form')
        //exibindo wrapper .groups-view
        offcanvas.showContent('.content')
    }

    this.toGroupList = () =>{
        let type = GENERAL_OPTIONS.station_type == 'plu' ? "pluviométricos" : "fluviométricos"
        //alterando titulo/subtitulo do offcanvas
        offcanvas.updateTitles("Seus grupos", "Lista de grupos de postos "+type)
        //escondendno wrapper .content
        offcanvas.hideContent('.content')
        //escondendo wrapper .groups-form
        offcanvas.hideContent('.groups-form')
        //exibindo wrapper .groups-view
        offcanvas.showContent('.groups-view')
        //atualizando lista de grupos
        group_list.update()
    }

    this.toGroupForm = (group = {}) =>{
        let station_type_id = GENERAL_OPTIONS.station_type == 'plu' ? 2 : 1
        //nova instancia de formulário
        group_form = new GroupForm(group,{
            container: "#group_form_container",
            groupable_list: _station.list,
            group_type_id: 1, //grupo de StationPrefix
            constraints:{station_type_id:station_type_id},
            current_select_func: current_select_func
        })
        
        //alterando titulo/subtitulo do offcanvas
        let title = ((group.id) ? "Editar " : "Novo ") + "grupo"
        let subtitle = (group.id) ? "Editar grupo de postos " : "Criar grupo de postos"
        offcanvas.updateTitles(title, subtitle)
        
        //escondendno wrapper .content
        offcanvas.hideContent('.content')
        //escondendo wrapper .groups-view
        offcanvas.hideContent('.groups-view')
        //exibindo wrapper .groups-form
        offcanvas.showContent('.groups-form')
        //gerando formulário
        group_form.generate()
    }
    //remover grupo
    this.destroyGroup = (group_id) =>{
        _http_v1.request('groups/'+group_id, 'delete', {}).then(_=>{
            toast.success({text: 'Grupo removido'})
            group_list.update()
        }).fail(data=>{
            console.log(data);
            toast.warning({text: 'Erro ao remover grupo'})
        })
        
    }

    this.updateListCounter = (value) =>{
        value = value || _station.list.filter(x=>x.listItem.isSelected()).length
        count.update(value)
    }

    this.addWrapper = (class_name) =>{
        offcanvas.appendContent(class_name)
    }

    function current_select_func(){
        let current_selected = _station.list.filter(x=>x.selected).map(x=>x.id);
        group_form.setMembers(current_selected)
    }

    function eventHandler(){
        //evento disparado quando o usuario altera o valor da caixa de pesquisa
        $(selectors.search).on('input:change', (e,data)=>{
            this.filter()
        })
    }
}